export const BundleProduct = () => ({
  currentStep: 1,
  stepTitles: {
    1: 'Choose your flavor',
    2: 'Boost your blend',
    3: 'Choose your frequency',
  },

  goToNextStep(step) {
    this.currentStep = step;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  goToProduct(handle, flavor) {
    if (typeof window !== 'undefined' && window.location) {
      window.location.href = `/products/${encodeURIComponent(handle)}${flavor && '?flavor=' + flavor}`;
    } else {
      console.error('Navigation failed: window object is unavailable.');
    }
  }
});
